import { Button, Stack, Typography } from "@mui/material";
import useItemStore from "../../stores/useItemStore";
import { useEffect } from "react";
import getItems from "../../api/auth/items/getItems";
import WushPopover from "../../components/layout/WushPopover";
import ItemForm from "../../components/form/item/ItemForm";
import deleteItem from "../../api/auth/items/deleteItem";
import ItemTable from "../../components/displays/items/ItemTable";

export default function Inventory() {
  const { items, setItems, removeItem } = useItemStore();

  useEffect(() => {
    getItems((response) => {
      setItems(response);
    });
  }, []);

  const handleDelete = (itemCategory) => {
    deleteItem(itemCategory.id, () => {
      removeItem(itemCategory);
    });
  };

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Items
        </Typography>
        <Typography variant="body1">
          Manage individual items. These items can be added to different item groups and have specific quantities and prices.
        </Typography>
      </Stack>
      <Stack mb={2}>
        <WushPopover
          anchor={
            <Button variant="contained" color="primary">
              Add Item
            </Button>
          }
        >
          <Stack p={2}>
            <ItemForm />
          </Stack>
        </WushPopover>
      </Stack>
      <Stack>
        <ItemTable handleDelete={handleDelete} items={items} />
      </Stack>
    </Stack>
  );
}